export default {"src":"/_next/static/media/azure-dark.8809fa51.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};